import { render, staticRenderFns } from "./SendEmailToReferralModal.vue?vue&type=template&id=a7a6971e"
import script from "./SendEmailToReferralModal.vue?vue&type=script&lang=js"
export * from "./SendEmailToReferralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports